export const TRAVEL_INSURANCE_STEPS = {
    LANDING: 'step-0-1',
    TRAVELERS_SETUP: 'step-1-1',
    CHOOSE_INSURANCE: 'step-1-2',
    CUSTOMER_LOGIN: 'step-1-3',
    POLICYHOLDER_INFORMATION: 'step-1-4',
    INSURED_PERSONS: 'step-1-5',
    SUMMARY: 'step-1-6',
    PAYMENT: {
        METHOD_TYPE: 'step-2-1',
        BANKS: 'step-2-2',
    },
};
